"use client";

import { useTranslations } from "@/app/(site)/europe/useTranslations";

export const CustomizationHeader = () => {
  const { customizationsHeadline, customizationsBody } = useTranslations();

  return (
    <div className="text-center mb-10">
      <h2 className="mx-auto max-w-[570px] mb-8">{customizationsHeadline}</h2>
      <p className="mx-auto max-w-[450px]">{customizationsBody}</p>
    </div>
  );
};
